<template>
	<div>
		<!-- BIG SLOGAN -->
		<div class="container">
			<h1 class="mb-30">{{ $t("start.header") }}</h1>
		</div><!-- .container -->

		<div class="container">
			<div class="row">
				<div class="col-md-6">
					<button @click="redirect('new_crowdfunding')" class="btn-tile start-campaign mb-20">
						<h3 class="text-center mb-20">{{ $t("start.aProject") }}</h3>
						<h4 class="text-center mb-20"><sub><span class="logo-font domore-yellow">{{ $t("start.do") }}</span><span class="logo-font domore-blue-1">{{ $t("start.more") }}</span></sub> <strong>{{ $t("start.projectDescription") }}</strong></h4>
						<h4 class="domore-blue-2-light mb-20">{{ $t("start.projectFee") }}</h4>
						<span class="crowd-or-rais"><span class="domore-blue-1">CROWDFUNDING</span></span>
					</button>
				</div><!-- .col-md-6 -->
				<div class="col-md-6">
					<button @click="redirect('new_fundraising')" class="btn-tile start-campaign mb-20">
						<h3 class="text-center mb-20">{{ $t("start.aCause") }}</h3>
						<h4 class="text-center mb-20"><sub><span class="logo-font domore-yellow">{{ $t("start.do") }}</span><span class="logo-font domore-blue-1">{{ $t("start.more") }}</span></sub> <strong>{{ $t("start.causeDescription") }}</strong></h4>
						<h4 class="domore-blue-2-light mb-20">{{ $t("start.causeFee") }}</h4>
						<span class="crowd-or-rais"><span class="domore-yellow">FUNDRAISING</span></span>
					</button>
				</div><!-- .col-md-6 -->
			</div><!-- .row -->
		</div><!-- .container -->

		<!-- STAR BOX -->
		<div class="container mt-50 mb-50">
			<p class="center"><img src="~assets/img/star.png"></p>
		</div><!-- .container .mt-50 .mb-50 -->

    <!-- Modal Log In-->
    <login-modal v-if="showLogin" :close="closeLogin"></login-modal>
	</div>
</template>

<script>
import LoginModal from '@/components/Header/LoginModal';
import auth from '@/api/v1/auth/authService';

export default {
  components: { LoginModal },
  data() {
    return {
      showLogin: false,
    };
  },
  methods: {
    redirect(routeName) {
      const url = !auth.user.email ? (this.showLogin = true) : this.$router.push({ name: routeName });
      return url;
    },
    closeLogin() {
      this.showLogin = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// StartCampaign.vue?bfb64862